/**
 * An article's accent, used as TEXT rather than as a fill.
 *
 * Every article carries an accent, and the journal paints the category label
 * ("News", "Guide · Owners") and the "Read article" link in it. That works
 * until an accent is light: silver on the light theme is about 1.3:1 against
 * the page, which is not low contrast so much as invisible. The launch post
 * shipped that way on 2026-10-01 — the label and the link were simply not
 * there in light mode.
 *
 * Darkening the accent is the wrong fix, because the same value has to read on
 * the dark theme too, where the problem runs the other way. So the accent is
 * pulled halfway to whatever the foreground currently is: toward near-black on
 * the light theme, toward near-white on the dark one. A vivid accent stays
 * recognisably itself at 55%; a pale one gains the contrast it was missing.
 *
 * The dot beside the label keeps the raw accent. It is decorative, it has a
 * glow, and nobody has to read it.
 */
export function accentText(accent: string): string {
  return `color-mix(in srgb, rgb(${accent}) 55%, var(--pg-fg))`
}
